const ACTION_CELL_MARGIN = 30;
const ACTION_BUTTON_WIDTH = 30;
const ACTION_BUTTON_PADDING = 10;

export default function actionColWidth(buttonCount: number) {
  const width = ACTION_CELL_MARGIN + buttonCount * (ACTION_BUTTON_WIDTH + ACTION_BUTTON_PADDING);

  return `${width}px`;
}
